<!--
 * @Author: your name
 * @Date: 2021-09-26 16:39:44
 * @LastEditTime: 2022-04-12 18:09:59
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-business\strategy\logistics\index.vue
-->
<template>
  <div class="app-container">
    <BjDivider
      >{{ $t('settingLogisticsStrategyConfig.logisticsStrategy') }}
      <template>
        <span class="text-muted font12 ml0">* {{ $t('settingLogisticsStrategyConfig.logisticsStrategyText') }}</span>
      </template>
    </BjDivider>
    <draggable
      v-model="list"
      ghost-class="ghost"
      chosen-class="chosen"
      force-fallback="true"
      group="people"
      animation="300"
      filter=".forbid"
      :disabled="disabled"
      draggable=".item"
      @start="onStart"
    >
      <div v-for="item in list" :key="item.typeCode" class="item">
        <div>
         {{ $t('settingLogisticsStrategyConfig.'+item.typeCode) }}
          <el-button type="text" class="ml20" @click="onView(item)">{{ item.text }}</el-button>
        </div>
        <el-switch v-model="item.enabledFlag" class="switch" />
      </div>
    </draggable>
    <el-form ref="form" :model="defaultLogistics">
      <BjDivider>{{ $t('settingLogisticsStrategyConfig.logisticsSettings') }}</BjDivider>
      <el-form-item>
        <el-radio-group v-model="logisticsSetting">
          <el-radio :label="1">{{ $t('settingLogisticsStrategyConfig.freightRadio') }}</el-radio>
          <el-radio :label="2">{{ $t('settingLogisticsStrategyConfig.priorityRadio') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <BjDivider
        >{{ $t('settingLogisticsStrategyConfig.defaultLogistics') }}
        <template>
          <span class="text-muted font12 ml0">* {{ $t('settingLogisticsStrategyConfig.defaultLogisticsText') }}</span>
        </template>
      </BjDivider>

      <el-descriptions title="" direction="vertical" :column="4" border>
        <el-descriptions-item
          :label-style="{ 'text-align': 'center' }"
          :content-style="{ 'text-align': 'center' }"
          :label="$t('settingLogisticsStrategyConfig.table.logisticsProviderName')"
        >
          <el-form-item
            prop="companyId"
            :rules="rules.logisticsProviderName"
          >
            <BjSelectLogisticCompany
              v-model="defaultLogistics.companyId"
              :default-options="{
                label: defaultLogistics.companyName,
                value: defaultLogistics.companyId,
              }"
              clearable
              style="width: 200px !important"
              @change="changeCompanyId"
            />
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item
          :label-style="{ 'text-align': 'center' }"
          :content-style="{ 'text-align': 'center' }"
          :label="$t('settingLogisticsStrategyConfig.table.businessName')"
        >
          <el-form-item
            prop="businessId"
            :rules="rules.businessName"
          >
            <BjSelectLogisticBusiness
              v-model="defaultLogistics.businessId"
              :disabled="!defaultLogistics.companyId"
              :default-params="defaultParams"
              :default-options="{
                label: defaultLogistics.businessName,
                value: defaultLogistics.businessId,
              }"
              :placeholder="defaultLogistics.companyId ? $t('settingLogisticsStrategyConfig.selectDesignatedLogisticsBusiness') : $t('settingLogisticsStrategyConfig.selectDesignatedLogisticsProvider')"
              clearable
              style="width: 200px !important"
            />
          </el-form-item>
        </el-descriptions-item>
        <el-descriptions-item
          :label-style="{ 'text-align': 'center' }"
          :content-style="{ 'text-align': 'center' }"
          :label="$t('settingLogisticsStrategyConfig.table.packageBilling')"
        >
          <el-form-item
            prop="amount"
            :rules="rules.packageBilling"
          >
            <BjInputMoney v-model="defaultLogistics.amount" style="width: 200px !important">
              <template #append> {{ $t('settingLogisticsStrategyConfig.pricePackage') }} </template>
            </BjInputMoney>
          </el-form-item>
        </el-descriptions-item>
      </el-descriptions>
      <!-- <el-form-item class="mt16" style="text-align: center"> -->
      <div style="text-align: center">
        <el-button type="primary" class="btn-default-width mt16" @click="onSubmit">{{ $t('saveText') }}</el-button>
      </div>
      <!-- </el-form-item> -->
    </el-form>
  </div>
</template>
<script>
const getDefaultForm = () => {
  return {
    amount: null, // 单个包裹的金额
    // businessCode: null, // 物流业务编码
    businessId: null, // 物流业务id
    businessName: null, // 物流业务名称
    // companyCode: null, // 物流商编码
    companyId: null, // 物流商id
    companyName: null, // 物流商名称
  };
};
import draggable from 'vuedraggable';
import { settingApi } from '@/api';
export default {
  name: 'SettingLogisticsStrategyConfig',
  components: {
    draggable,
  },
  data() {
    return {
      disabled: false,
      list: [],
      logisticsSetting: 1,
      defaultLogistics: getDefaultForm(),
    };
  },
  computed: {
    rules() {
      const rules = {
        packageBilling: [{required: true, message: this.$t('settingLogisticsStrategyConfig.table.packageBillingRules'), trigger: 'blur'}],
        businessName: [{required: true, message: this.$t('settingLogisticsStrategyConfig.table.businessNameRules'), trigger: 'change'}],
        logisticsProviderName: [{required: true, message: this.$t('settingLogisticsStrategyConfig.table.logisticsProviderNameRules'), trigger: 'change'}],
      };
      return rules;
    },
    strategy() {
      const strategy = {
        // 设置订单金额
        setOrderAmount: this.$t('settingLogisticsStrategyConfig.setOrderAmount'),
        // 设置指定商品
        designatedProduct: this.$t('settingLogisticsStrategyConfig.designatedProduct'),
        // 设置省市区
        setProvinces: this.$t('settingLogisticsStrategyConfig.setProvinces'),
        // 设置仓库
        setWarehouse: this.$t('settingLogisticsStrategyConfig.setWarehouse')
      };
      return strategy;
    },
    defaultParams() {
      // 以 所属物流商 为默认参数
      return { companyId: this.defaultLogistics.companyId, enableFlag: true };
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.list = [];
      settingApi.getStrategyLogistics().then(res => {
        this.defaultLogistics = Object.assign(getDefaultForm(), res.defaultLogistics || {});
        res.strategyList.forEach(e => {
          switch (e.typeCode) {
            case 'orderAmount':
              // 设置订单金额
              e.text = this.strategy.setOrderAmount;
              break;
            case 'goods':
              // 设置指定商品
              e.text = this.strategy.designatedProduct;
              break;
            case 'district':
              // 设置省市区
              e.text = this.strategy.setProvinces;
              break;
            case 'storehouse':
              // 设置仓库
              e.text = this.strategy.setWarehouse;
              break;
          }
        });
        // 重新排序：开启的数据放前面
        this.list = [
          ...res.strategyList.filter(e => e.enabledFlag),
          ...res.strategyList.filter(e => !e.enabledFlag),
        ];
        this.logisticsSetting = res.logisticsSetting;
      });
    },
    // 变更 物流商名称 时，需要重新选择 业务名称
    changeCompanyId() {
      this.defaultLogistics.businessId = null;
      console.warn('methods logisticsCompanyId');
    },
    onView(row) {
      let name = null;
      switch (row.typeCode) {
        case 'orderAmount':
          name = 'SettingLogisticsStrategyOrderMoneyIndex';
          break;
        case 'goods':
          name = 'SettingLogisticsStrategyAssignGoodsIndex';
          break;
        case 'district':
          name = 'SettingLogisticsStrategyZonesIndex';
          break;
        case 'storehouse':
          name = 'SettingLogisticsStrategyWarehouseIndex';
          break;
      }
      this.$toPage(name);
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (!valid) return this.$scrollToFormError();
        this.$confirm(this.$t('settingLogisticsStrategyConfig.confirmText'), this.$t('toast.hintText'), {
          confirmButtonText: this.$t('toast.okText'),
          cancelButtonText: this.$t('toast.cancelText'),
          type: 'warning',
        })
          .then(() => {
            settingApi
              .updateStrategyLogistics({
                strategyList: this.list,
                logisticsSetting: this.logisticsSetting,
                defaultLogistics: {
                  amount: this.defaultLogistics.amount, // 单个包裹的金额
                  businessId: this.defaultLogistics.businessId, // 物流业务id
                  companyId: this.defaultLogistics.companyId, // 物流商id
                },
              })
              .then(res => {
                if (!res.failed) {
                  this.msgSuccess(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.getData();
                  }, 500);
                }
              });
          })
          .catch(() => {});
      });
    },
    // 开始拖拽事件
    onStart() {
      this.disabled = false;
    },
  },
};
</script>
<style lang="scss" scoped>
/*被拖拽对象的样式*/
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background-color: #fff;
  border: solid 1px #eee;
  margin-bottom: 10px;
  cursor: move;
  border-radius: 4px;
}
.el-form-item {
  margin-top: 10px;
  display: inline-block;
  margin-bottom: 10px;
}
</style>
